import React from 'react';
import './styles/Footer.css';

const Footer = () => {
	return (
		<footer className="text-center text-lg-start">
			<div className="container" id="footer">
				<p className="text-center p-3">
					&copy; 2024 Mert Toprak. All rights reserved.
				</p>
			</div>
		</footer>
	);
};

export default Footer;
